<script>
	import { page } from '$app/stores';
	import { t } from '@resider/i18n';
	import Button from '../Button/Button.svelte';
	import Icon from '../Icon/Icon.svelte';
	import Badge from '../Badge/Badge.svelte';
</script>

<menu>
	<!-- <Button
		href="/{$page?.params?.lang}/{$t('slugs.chat')}{$page?.data.userChats?.length > 0
			? `/${$page?.data.userChats[0].id}`
			: ''}"
		kind={$page?.params.chat ? 'tertiary' : 'ghost-alt'}
	>
		<Icon slot="left" name="sparks" />

		{$t('global.AI Assistant')}
		<Badge
			size="sm"
			--hsl-badge-background="var(--hsl-primary), 0.15"
			--hsl-badge-text="var(--hsl-primary)">Beta</Badge
		>
	</Button> -->

	<slot MenuItem={Button} />
</menu>

<style>menu{--hsl-badge-background:var(--hsl-secondary);display:flex;gap:1rem}menu :global(.icon){--size:1.5rem}</style>
